<template lang="pug">
div.wrap-item-header-modal-window.w-full.py10
  div.header-content.f.flex-between.px12
    span.bold {{label}}
    v-icon(@click="$emit('closeModalWindow')" dark) mdi-close
</template>

<style lang="scss" scoped>
@import "@/scss/_variables.scss";

.wrap-item-header-modal-window {
  background: $dark_primary_bg_color;
  border-bottom: solid 0.6px rgba(255, 255, 255, 0.8);
  span {
    color: $dark_primary_text_color;
  }
}
</style>

<script>
export default {
  props: {
    label: {
      type: String,
      required: true
    }
  }
}
</script>
